var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"svg-inline",class:{ [`svg-inline-${_vm.name}`]: _vm.name },attrs:{"data-dir":_vm.dir,"data-flip":_vm.flip}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }